export default __webpack_public_path__ + "static/media/a011-3.7cdb5326.svg";